<kno2-dialog-body>
    <div class="alert alert-info">
        <p>
            <strong>This organization has been canceled.</strong>
            <br />
            You can request reactivation at anytime by clicking the "Request Reactivation" button below.
        </p>
    </div>
</kno2-dialog-body>

<kno2-dialog-footer>
    <button
        type="button"
        class="btn btn-inverse"
        (click)="cancel()">
        Cancel Reactivation
    </button>
    <button
        type="button"
        class="btn btn-primary"
        [disabled]="hasSubmitted()"
        (click)="sendRequest()">
        @if (hasSubmitted()) {
            <span class="spinner-border spinner-border-sm me-2"></span>
        }
        Request Reactivation
    </button>
</kno2-dialog-footer>
